function MoviesDetailsPage() {
	return <div>MoviesDetailsPage</div>
}

export default MoviesDetailsPage
